{
  "newAnnouncement": "Tem um novo anúncio",
  "notification": "Notificações e anúncios",
  "unread": "notificações não lidas"
}
